import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import * as ReactDOM from "react-dom/client";
import App from "./app/App";
import "./index.scss";
import { ApolloProvider } from "@apollo/client";
import apolloClient from "./utils/apolloClient";
import { BrowserRouter as Router } from "react-router-dom";
import { AppProvider } from "./store";
import "isomorphic-fetch";
import { MsalProvider } from "./utils/authContext";
import { msalConfig } from "./utils/authConfig";
import "./utils/analyticsClient";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Router basename={process.env.REACT_APP_ROUTER_BASENAME}>
    <MsalProvider config={msalConfig}>
      <AppProvider>
        <ApolloProvider client={apolloClient}>
          <App />
        </ApolloProvider>
      </AppProvider>
    </MsalProvider>
  </Router>
);
